const statusOptions = {
  0: '未提交',
  1: '不可提交',
  2: '成功',
  3: '失败'
}
export const cardOptions = {
  QUERY_WEIGHT_WORK_ORDER: {
    title: '【查重量】',
    list: [
      { label: '运单号', prop: 'waybillNo' },
      { label: '您的身份', prop: 'customerType' },
      { label: '您的姓名', prop: 'name' },
      { label: '反馈号码', prop: 'phone' },
      { label: '回复号码', prop: 'replyPhone' },
      { label: '反馈内容', prop: 'title' },
      { label: '详情描述', prop: 'remark' }
    ]
  },
  // 运单轨迹
  WAYBILL_TRACKS: {
    title: '【运单轨迹】',
    list: [
      { label: '运单号', prop: 'waybillNo' },
      { label: '发件城市', prop: 'senderCityName' },
      { label: '收件城市', prop: 'receiverCityName' },
      { label: '当前状态', prop: 'receiverCityName' },
      { label: '签收状态', prop: 'signStatus' }
    ]
  },
  // 网点列表
  NETWORK_LIST: {
    title: '亲,已为您查询到以下网点信息',
    list: [
      { label: '网点名称', prop: 'name' },
      { label: '网点电话', prop: 'phones' }
    ]
  },
  // 网点信息
  NETWORK_INFO: {
    title: '亲,已为您查询到以下网点信息',
    list: [
      { label: '网点名称', prop: 'name' },
      { label: '网点电话', prop: 'phones' }
    ]
  },
  // 修改信息
  MODIFY_INFO: {
    title: '【修改信息】',
    list: [
      {
        label: '提交状态', prop: 'status', formatter({ status }) {
          return statusOptions[status] || ''
        }
      },
      { label: '运单号', prop: 'waybillNo' },
      { label: '联系方式', prop: 'phone' },
      { label: '新收件电话', prop: 'newPhone' },
      { label: '新收件地址', prop: 'newAddress' },
      { label: '备注', prop: 'remark' }
    ]
  },
  // 信息登记
  INFO_RECORD: {
    title: '【信息登记】',
    list: [
      {
        label: '提交状态', prop: 'status', formatter({ status }) {
          return statusOptions[status] || ''
        }
      },
      { label: '运单号', prop: 'waybillNo' },
      { label: '联系方式', prop: 'phone' },
      { label: '备注', prop: 'remark' }
    ]
  },
    // 转寄登记
  INFO_CHANGE_INTERCEPT: {
    title: '【转寄登记】',
    list: [
      {
        label: '运单号',
        prop: 'waybillNo'
      },
      {
        label: '您的身份',
        prop: 'customerType',
        formatter({ customerType }) {
          return ['', '寄件人', '收件人', '其他'][customerType] || ''
        }
      },
      {
        label: '您的姓名',
        prop: 'receiverName'
      },
      {
        label: '反馈号码',
        prop: 'feedbackPhone'
      },
      {
        label: '回复电话',
        prop: 'replyPhone'
      },
      {
        label: '反馈内容',
        prop: 'modifyType',
        formatter({ modifyType }) {
          return ['', '修改收件地址', '修改收件号码', '修改收件地址&号码'][modifyType] || ''
        }
      },
      {
        label: '新的收件地址',
        prop: 'newAddress'
      },
      {
        label: '详细地址',
        prop: 'receiverDetailedAddress'
      },
      {
        label: '新的收件号码',
        prop: 'receiverTelephone'
      },
      {
        label: '详情描述',
        prop: 'rebackTransferReason'
      }
    ]
  }
}
